import { IStyleConfig, mergeStyles } from '@cian/components';
import * as React from 'react';

export interface IBoxProps {
  top?: number | 'auto';
  left?: number | 'auto';
  right?: number | 'auto';
  bottom?: number | 'auto';
  x?: number | 'auto';
  y?: number | 'auto';
  boxStyles?: IStyleConfig;
}

export class Box extends React.PureComponent<IBoxProps, {}> {
  public render() {
    const { x, y, ...props } = this.props;

    const style: IStyleConfig = {
      marginBottom: props.bottom || y,
      marginLeft: props.left || x,
      marginRight: props.right || x,
      marginTop: props.top || y,
    };

    const boxStyles = mergeStyles(style, props.boxStyles);

    return <div {...boxStyles}>{props.children}</div>;
  }
}
